import { createContext, useContext } from "react";

import type { PageHeaderViewModel } from "./types-page-header";

export const PageHeaderContext = createContext<PageHeaderViewModel | null>(null);

export function usePageHeaderContext(): PageHeaderViewModel {
  const context = useContext(PageHeaderContext);
  if (!context) throw new Error("PageHeader.* deve ser usado dentro de PageHeader.Root");
  return context;
}
